import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Heading } from '@pandiafi/design-system'

import { DefectNoticeEvent } from '../../../../../../common/validations/defectNotice'
import { Section, TextTable } from '../../../../../components'
import { renderDate } from '../../../../../utils'
import { renderEventType } from '../../../utils'

export const DefectNoticeEvents: FC<{
  events?: DefectNoticeEvent[]
}> = ({ events }) => {
  const { t } = useTranslation('defectNotice')

  if (!events) {
    return null
  }

  return (
    <Section className="my-12">
      <Heading size="xs" element="h3" semibold>
        {t('texts.eventsTitle')}
      </Heading>
      <TextTable className="min-tablet:text-lg">
        {events.map((evt) => (
          <TextTable.Row key={evt.id}>
            <TextTable.Cell>
              {renderDate(evt.workFinishedAt || evt.createdAt)}
            </TextTable.Cell>
            <TextTable.Cell>{renderEventType(evt)}</TextTable.Cell>
          </TextTable.Row>
        ))}
      </TextTable>
    </Section>
  )
}
